import { createContext, useRef } from "react";
import { GET_PAID_STEP } from "types/get_paid";

export const GetPaidFormContext = createContext<{
  isMixpanelStepTriggered: React.MutableRefObject<{
    [GET_PAID_STEP.ORGANIZATION_INFO]: boolean;
    [GET_PAID_STEP.AUTOMATION]: boolean;
    [GET_PAID_STEP.ACTIVATION]: boolean;
  }> | null;
}>({
  isMixpanelStepTriggered: null,
});

export const GetPaidFormProvider = ({ children }: { children: React.ReactNode }) => {
  const isMixpanelStepTriggered = useRef({
    [GET_PAID_STEP.ORGANIZATION_INFO]: false,
    [GET_PAID_STEP.AUTOMATION]: false,
    [GET_PAID_STEP.ACTIVATION]: false,
  });

  return (
    <GetPaidFormContext.Provider
      value={{
        isMixpanelStepTriggered,
      }}
    >
      {children}
    </GetPaidFormContext.Provider>
  );
};
